// 元数据
import request from "../utils/request";

export function queryBusinessInfo(formId){
    let data={'data':{
        'FormId':formId
    }}
    return request({
        method:'POST',
        url:'/Kingdee.BOS.WebApi.ServicesStub.DynamicFormService.QueryBusinessInfo.common.kdsvc',
        data:data
    })
}

